// QuizScale.js
import React, { useEffect, useState } from "react";
import ScaleContext from './ScaleContext';

const QuizScale = ({ children }) => {
  const [scaleFactor, setScaleFactor] = useState(1);

  useEffect(() => {
    //check if it is iframe or not
    if (true){//window.self !== window.top) {
      const params = new URLSearchParams(window.location.search);
      const scaleParam = params.get("scale");

      if (scaleParam) {
        const scale = parseFloat(scaleParam);
        setScaleFactor(scale);

        const quizContainer = document.getElementById("quiz-container");
        if (quizContainer) {
          quizContainer.style.transform = `scale(${scale})`;
          quizContainer.style.transformOrigin = "top left";
          quizContainer.style.width = `${100 / scale}%`;
          quizContainer.style.height = `${100 / scale}%`;
        }
      }
    }
  }, []);
  return (
    <ScaleContext.Provider value={scaleFactor}>
      {children}
    </ScaleContext.Provider>
  );
};

export default QuizScale;
